export const getFormatedCycleString = (
  cycle:
    | "every_one_weeks"
    | "every_two_weeks"
    | "every_three_weeks"
    | "every_four_weeks"
    | "custom",
  currentLang: "en" | "ar" = "ar"
) => {
  const repeats = {
    every_one_weeks: currentLang === "ar" ? "أسبوع واحد" : "One Week",
    every_two_weeks: currentLang === "ar" ? "أسبوعين" : "Two Weeks",
    every_three_weeks: currentLang === "ar" ? "ثلاثة أسابيع" : "Two Weeks",
    every_four_weeks: currentLang === "ar" ? "أربعة أسابيع" : "Four Weeks",
    custom: currentLang === "ar" ? "مخصص" : "Custom",
  };
  return repeats[cycle] || "";
};
